import type { FC } from 'react'
import { Outlet } from 'react-router-dom'

import { TeamsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/teams/lib/CollectionsBootstrap'

const RootPage: FC = () => {
  const { data, loading } = useQuery(TeamsRootPageDocument)

  const canSeeTeamsSection = data?.teams._policies.companySeeTeamsSection.can

  if (loading) return <></>

  return (
    <AuthorizeUser authorizeFn={() => canSeeTeamsSection ?? false}>
      <CollectionsBootstrap>
        <Outlet />
      </CollectionsBootstrap>
    </AuthorizeUser>
  )
}

export default RootPage
